import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class NotFoundLink extends Component {
  render(){

    return(
      <div className="not-found-link">
          <h4 className="no-margin not-found-heading">Can't find your business in this list?</h4>
          <Link to="/getfound">Contact us to get it added <i className="fa fa-arrow-circle-o-right fa-lg" aria-hidden="true"></i></Link>
        </div>
    );
  }
}
export default NotFoundLink;


// WEBPACK FOOTER //
// ./src/components/pieces/NotFoundLink.js